import { getPatternStyles, patternFns } from '../helpers.js';
import { css } from '../css/index.js';

const linkConfig = {
transform:({ style, bold, align, shadow, italic, color, ...rest }) => ({
  textStyle: style,
  textAlign: align,
  textShadow: shadow,
  fontWeight: bold ? "bold" : void 0,
  fontStyle: italic ? "italic" : void 0,
  color: color || "purple.200",
  transitionProperty: "opacity",
  transitionDuration: "normal",
  transitionTimingFunction: "ease-in-out",
  display: "inline-block",
  cursor: "pointer",
  position: "relative",
  _after: {
    content: '""',
    display: "block",
    width: "[0]",
    height: "[0.125rem]",
    rounded: "[0.125rem]",
    position: "absolute",
    bg: "[currentColor]",
    transitionProperty: "width, opacity",
    transitionDuration: "normal",
    transitionTimingFunction: "ease-in-out",
    opacity: 0,
    bottom: "0",
    ...rest._after
  },
  _hover: {
    opacity: 0.6,
    _after: {
      width: "full",
      opacity: 0.6,
      ...rest._hover?._after
    },
    ...rest._hover
  },
  ...rest
})}

export const getLinkStyle = (styles = {}) => {
  const _styles = getPatternStyles(linkConfig, styles)
  return linkConfig.transform(_styles, patternFns)
}

export const link = (styles) => css(getLinkStyle(styles))
link.raw = getLinkStyle